import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { finalize, map, tap } from 'rxjs/operators';
import { ErrorService } from 'src/app/services/error.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { GetCustomers, SearchCustomersRequest, SearchCustomersResponse, UpdateUserRequest } from './search-customers.interface';
import { ApiResponse, ServicesResponse } from "@core/model/servicesResponse";

@Injectable({
  providedIn: 'root'
})
export class SearchCustomersService {
  irenYouEmail: string;
  irenYouEmailCustomer: string;
  isLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient,
    private errorService: ErrorService,
    private notificationService: NotificationService,
    private router: Router
  ) { }
  getCustomerMails(parametri: SearchCustomersRequest): Observable<string[]> {
    this.isLoading$.next(true);
    const params = new HttpParams()
      .set('searchEmail', parametri.searchEmail.trim())
      .set('searchCf', parametri.searchCf.trim())
      .set('searchPiva', parametri.searchPiva.trim())
      .set('searchUserId', parametri.searchUserId.trim())
      .set('sortOrder', parametri.sortOrder.trim())
      .set('pageNumber', parametri.pageNumber.toString().trim())
      .set('pageSize', parametri.pageSize.toString().trim())
      .set('sortField', parametri.sortField.trim());

    return this.http.get<SearchCustomersResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/ricercaGenerica`, { params })
      .pipe(
        map(response => response.data),
        finalize(() => this.isLoading$.next(false)),
      );
  }

  getCustomerProfilesByMail(email: string): Observable<GetCustomers> {
    const params = new HttpParams()
      .set('searchEmail', email.trim());

    return this.http.get<any>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/ricercaEmail`, { params })
      .pipe(
        map(res => ({
          dataRegistrazione: res.data?.created,
          userId: res.data?.userid,
          cf: res.data?.codiceFiscale,
          dataUltimoAccesso: res.data?.lastLogonTime,
          nome: res.data?.givenname,
          utenzaBloccata: res.data?.accountLocked === 'true',
          gruppoAutorizzazione: res.data?.gruppoAutorizzazione,
          telefonoRegistrazione: res.data?.telephone,
          email: res.data?.emailaddress,
          cognome: res.data?.lastname,
          piva: res.data?.partitaIva,
          tipoIscrizione: res.data?.socialType,
          ragioneSociale: res.data?.ragioneSociale,
          tipoAccount: res.data?.tipoAccount,
          accettazionePrivacy: res.data?.accettazionePrivacy,
          accettazioneTermini: res.data?.accettazioneTermini,
          versioneDocPrivacy: res.data?.versioneDocPrivacy,
          versioneDocTermini: res.data?.versioneDocTermini,
          sorgentePrivacy: res.data?.sorgentePrivacy,
          sorgenteTermini: res.data?.sorgenteTermini,
          sorgente: res.data?.sorgente,
          dataAutenticazioneForte: res.data?.dataAutenticazioneForte,
          autenticazioneForte: res.data?.autenticazioneForte,
        })),
      );
  }

  deleteAccount(email): Observable<ServicesResponse> {
    this.isLoading$.next(true);
    return this.http.post<ServicesResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/cancellaUtenteWeb`, email).pipe(
      tap(response => {
        this.isLoading$.next(false);

        if (response.status.codice !== '000') {
          const errorMessage = "Si è verificato un errore in fase di cancellazione.";
          this.errorService.setError(errorMessage);
          throw new Error(errorMessage);
        } else {
          this.notificationService.setNotification("Account cancellato con successo.");
          this.router.navigate(['/private-area', 'search-customers'], { state: { email: email.email } });
        }
      }),
      map(response => response)
    );
  }

  updateUser(updateUserRequest: UpdateUserRequest): Observable<ServicesResponse> {
    this.isLoading$.next(true);
    return this.http.post<ServicesResponse>(`${environment.DASHBOARD_PRIVATE_BASE_URL}/updateUser`, updateUserRequest).pipe(
      tap(response => {
        this.isLoading$.next(false);

        if (response.status.codice !== '000') {
          const errorMessage = "Si è verificato un errore in fase di aggiornamento dati.";
          this.errorService.setError(errorMessage);
          throw new Error(errorMessage);
        } else {
          this.notificationService.setNotification("Dati aggiornati con successo.");
          this.router.navigate(['/private-area', 'search-customers'], { state: { email: updateUserRequest.email } });
        }
      }),
      map(response => response)
    );
  }

  getIrenYouEmail() {
    return this.irenYouEmail;
  }
  setIrenYouEmail(email: string) {
    return this.irenYouEmail = email;
  }
  getIrenYouEmailCustomer() {
    return this.irenYouEmailCustomer;
  }
  setIrenYouEmailCustomer(email: string) {
    return this.irenYouEmailCustomer = email;
  }
}
